<template>
  <div class="box">
    <el-row>
      <el-col :span="2" style="height:10px"> </el-col>
      <el-col :span="20">
        <div class="xingxi">
          <div class="tiao"></div>
          <i>其他服务</i>
        </div>
        <router-link to="order" class="fanhui">&lt;返回</router-link>
        <el-form
          :model="editForm"
          label-position="top"
          style="margin-top: 20px;"
          ref="editForm"
          :rules="editRules"
        >
          <el-card style="margin-top: 20px;">
            <el-row>
              <el-col :span="8" :push="2">
                <h4><i style="color:#FF0000">*</i> 需求说明</h4>
              </el-col>
              <el-col :span="16" :pull="2">
                <el-form-item prop="xiangmuyusuan">
                  <p>项目预算</p>

                  ￥
                  <el-input
                    placeholder="请输入"
                    style="width: 140px;"
                    v-model="editForm.xiangmuyusuan"
                  ></el-input>
                  元
                </el-form-item>
                <p>项目周期</p>
                <el-radio-group v-model="accuracy">
                  <el-radio label="有">有</el-radio>
                  <el-radio label="无">无</el-radio>
                </el-radio-group>
                <el-form-item prop="xiangmuzhouqi" v-if="this.accuracy == '有'">
                  <i style="font-size:12px;margin-right: 10px">项目周期</i>
                  <el-date-picker
                    v-model="editForm.xiangmuzhouqi"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 320px;"
                  ></el-date-picker>
                </el-form-item>
                <p>项目所在地</p>
                <v-distpicker
                  hide-area
                  @province="onChangeProvince"
                  @city="onChangeCity"
                ></v-distpicker>
                <el-form-item prop="lianxiren">
                  <p>联系人</p>
                  <el-input
                    placeholder="请输入"
                    style="width: 320px;"
                    v-model="editForm.lianxiren"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="shoujihao">
                  <p>联系人手机号</p>
                  <el-input
                    placeholder="请输入"
                    style="width: 320px;"
                    v-model="editForm.shoujihao"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="zhiwu">
                  <p>联系人职务</p>
                  <el-input
                    placeholder="请输入"
                    style="width: 320px;"
                    v-model="editForm.zhiwu"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="xiangxiyaoqiu">
                  <p>详细要求</p>
                  <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    v-model="editForm.xiangxiyaoqiu"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </el-form>
        <div class="clearfix" style="margin-bottom:30px">
          <el-button
            @click="submission()"
            type="primary"
            style="float: right;margin-top: 10px;"
            >申请提交</el-button
          >
        </div>
      </el-col>
      <el-col :span="2" style="height:10px"> </el-col>
    </el-row>
  </div>
</template>

<script>
import VDistpicker from "v-distpicker";
// import moment from "moment";
export default {
  components: { VDistpicker },
  data() {
    var validate = (rule, value, callback) => {
      let boolean = /^(0|[1-9][0-9]*)(\.\d+)?$/;
      if (!boolean.test(value)) {
        callback(new Error("只可以输入正数"));
      } else {
        callback();
      }
    };
    return {
      editForm: {
        xiangmuyusuan: "",
        lianxiren: "",
        shoujihao: "",
        zhiwu: "",
        xiangxiyaoqiu: "",
        xiangmuzhouqi: ""
      },
      editRules: {
        xiangmuyusuan: [
          { required: true, message: "请输入", trigger: "blur" },
          { validator: validate, trigger: "blur" }
        ],
        lianxiren: [{ required: true, message: "请输入", trigger: "blur" }],
        shoujihao: [
          { required: true, message: "请输入", trigger: "blur" },
          { max: 11, message: "长度在11位手机号", trigger: "blur" }
        ],
        zhiwu: [{ required: true, message: "请输入", trigger: "blur" }],
        xiangxiyaoqiu: [{ required: true, message: "请输入", trigger: "blur" }],
        xiangmuzhouqi: [
          { required: true, message: "请选择日期", trigger: "change" }
        ]
      },

      requirement: [],
      checkList: [],

      //成果精度多选
      accuracy: "有",
      sheng: "",
      shi: "",
      upform: {
        function: "t_order",
        jsonData: {
          type: "5",
          // createTime: "",
          data: {},
          userId: ""
        }
      }
    };
  },
  created() {
    this.sessionData();
  },
  methods: {
    async sessionData() {
      let config = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      };
      const { data: dt } = await this.$http.post(
        "user/getUserInfo",
        "",
        config
      );
      if (dt.status == 500) {
        this.$confirm("身份认证过期请重新登陆", "退出", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            window.sessionStorage.removeItem("token");
            // window.sessionStorage.removeItem("tempData");
            this.$router.push("/login");
          })
          .catch(() => {});
        // return this.$message.error("身份认证过期请重新登陆");
      }
      this.testData = dt.data;
      this.upform.jsonData.userId = this.testData.id;
      // console.log(this.upform.jsonData.userId)
    },
    submission() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认要提交其他服务么?", "提交", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(async () => {
              // var tm = moment(new Date().getTime()).format("YYYY-MM-DD HH:mm:ss");
              // this.upform.jsonData.createTime = tm;
              if (this.accuracy == "有") {
                this.upform.jsonData.data.xiangmuzhouqi = this.editForm.xiangmuzhouqi;
              } else if (this.accuracy == "无") {
                this.upform.jsonData.data.xiangmuzhouqi = this.accuracy;
              }
              this.upform.jsonData.data.xiangmuyusuan = this.editForm.xiangmuyusuan;
              this.upform.jsonData.data.lianxiren = this.editForm.lianxiren;
              this.upform.jsonData.data.shoujihao = this.editForm.shoujihao;
              this.upform.jsonData.data.zhiwu = this.editForm.zhiwu;
              this.upform.jsonData.data.xiangxiyaoqiu = this.editForm.xiangxiyaoqiu;
              this.upform.jsonData.data.shengshi = this.sheng + this.shi;

              this.upform.jsonData.data = JSON.stringify(
                this.upform.jsonData.data
              );
              this.upform.jsonData = JSON.stringify(this.upform.jsonData);

              const { data: dt } = await this.$http.post(
                "general/insert",
                this.upform
              );
              if (dt.status == 500) {
                this.$confirm("身份认证过期请重新登陆", "退出", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                })
                  .then(() => {
                    window.sessionStorage.removeItem("token");
                    // window.sessionStorage.removeItem("tempData");
                    this.$router.push("/login");
                  })
                  .catch(() => {});
                // return this.$message.error("身份认证过期请重新登陆");
              }
              if (dt.status !== 200) {
                return this.$message.error(dt.msg);
              }
              this.$router.push("/users");
            })
            .catch(() => {});
        }
      });
    },
    //获取选择的省市
    onChangeProvince(a) {
      this.sheng = a.value;
    },
    onChangeCity(a) {
      this.shi = a.value;
    }
  }
};
</script>

<style lang="less" scoped>
.el-card {
  overflow: auto;
}
.box {
  position: relative;
  background: #f2f2f2;
}
.fanhui {
  position: absolute;
  top: 90px;
  right: 8%;
}
i {
  font-style: normal;
}
.xingxi {
  width: 90px;
  margin-top: 90px;
  // position: absolute;
  // left: 70px;
  // top: 60px;
  .tiao {
    width: 4px;
    height: 15px;
    background: rgba(0, 134, 253, 1);
    display: inline-block;
    margin-right: 10px;
  }
  i {
    // width: 65px;
    font-weight: bold;
    font-size: 16px;
  }
}
</style>
